import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<header ...attributes>\n    {{#if @title}}\n        <h4>{{@title}}</h4>\n    {{/if}}\n\n    {{yield}}\n</header>")